import * as React from 'react';
import { useState } from "react";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Switch from '@mui/material/Switch';
import WifiIcon from '@mui/icons-material/Wifi';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { API_URL } from "../../../services/api-uri"
import BluetoothIcon from '@mui/icons-material/Bluetooth';
import axios from "axios";
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { toast } from 'react-toastify';
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';
import TaskIcon from '@mui/icons-material/Task';
import DescriptionIcon from '@mui/icons-material/Description';
import Menu from '@mui/material/Menu';
import DownloadIcon from '@mui/icons-material/Download';
import MenuItem from '@mui/material/MenuItem';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

import { Grid, IconButton, Button, InputLabel, Select, Checkbox } from "@mui/material";

import Paper from "@mui/material/Paper";
import { AirportShuttle } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

const DocumentsDetails = ({
    booking_id,
    listUsers,
    userID, setUserId,
    invoiceSent, setInvoiceSent,
    visaSent, setVisaSent,
    transferInfoSent, setTransferInfoSent,
    paymentConfirmationSent, setPaymentConfirmationSent,
    paymentDepositConfirmationSent, setPaymentDepositConfirmationSent,
    bookingConfirmationSent, setBookingConfirmationSent,
    creditNoteSent, setCreditNoteSent,
    creditNoteNumber, invoiceNumber,
    handleWeeksChange, weeks,
    studentLastName, studentFirstName,
    certificateSent, setCertificateSent
}) => {

    const [loading, setLoading] = useState(false);
    const [selectedFileType, setSelectedFileType] = useState([])
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event, file_type) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAgentChange = (e) => {
        setUserId(e.target.value);
        handleWeeksChange(weeks, e.target.value);
    }

    const getMailBtnLibelle = () => {
        if (listUsers) {
            let user = listUsers.filter((u) => u.id == userID)[0]
            //Pré
            if (user && user.commissionType == 2) {
                return `Send by mail (net)`;
            }
            //Post commission
            if (user && user.commissionType == 3) {
                return `Send by mail (gross)`;
            }
            else {
                return "Send by mail (gross)"
            }
        } else {
            return "Send by mail";
        }
    }

    const getFileName = (selected) => {
        switch (selected) {
            case 1:
                return `${studentFirstName}${studentLastName}-${"BookingConfirmation"}.pdf`;
            case 2:
                return `${studentFirstName}${studentLastName}-${"TravelConfirmation"}.pdf`;
            case 3:
                return `${studentFirstName}${studentLastName}-${"GrossInvoice"}.pdf`;
            case 4:
                return `${studentFirstName}${studentLastName}-${"NetInvoice"}.pdf`;
            case 5:
                return `${studentFirstName}${studentLastName}-${"DepositConfirmation"}.pdf`;
            case 6:
                return `${studentFirstName}${studentLastName}-${"PaymentConfirmation"}.pdf`;
            case 7:
                return `${studentFirstName}${studentLastName}-${"Visa"}.pdf`;
            case 8:
                return `${studentFirstName}${studentLastName}-${"CreditNote"}.pdf`;
            case 9:
                return `${studentFirstName}${studentLastName}-${"Certificate"}.pdf`;
        }
    }

    const generateFile = async (sendMail) => {
        try {
            setLoading(true)
            const response = await axios.get(`${API_URL}Documents/GenerateFile/${booking_id}?types=${selectedFileType.join('-')}&sendMail=${sendMail}`, {
                responseType: 'arraybuffer',
            });
            setLoading(false)

            const file = new Blob([response.data], {
                type: selectedFileType.length === 1 ? 'application/pdf' : 'application/zip',
            });





            if (!sendMail) {
                const fileUrl = URL.createObjectURL(file);
                const anchor = document.createElement('a');
                anchor.href = fileUrl;
                anchor.download = selectedFileType.length === 1 ? getFileName(selectedFileType[0]) : 'files.zip';
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                URL.revokeObjectURL(fileUrl);
            } else {

                selectedFileType.forEach(element => {
                    switch (element) {
                        case 1:
                            setBookingConfirmationSent(true)
                            break;
                        case 2:
                            setTransferInfoSent(true)
                            break;
                        case 3:
                            setInvoiceSent(true)
                            break;
                        case 4:
                            setInvoiceSent(true)
                            break;
                        case 5:
                            setPaymentDepositConfirmationSent(true)
                            break;
                        case 6:
                            setPaymentConfirmationSent(true)
                            break;
                        case 7:
                            setVisaSent(true)
                            break;
                        case 8:
                            setCreditNoteSent(true)
                            break;
                        case 9:
                            setCertificateSent(true);
                            break;
                    }
                });

                setSelectedFileType([])

                toast.success('Attachment(s) sent successfuly', { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER });
            }
        } catch (error) {
            setLoading(false)
            toast.error('Error generating or downloading the files', { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER });
        }
    };

    console.log(selectedFileType)

    return (

        <Paper elevation={3} display="flex" className={"step-container"}>
            <Grid container direction="row" justifyContent="left" alignItems="left" spacing={1} >
                <label>Agent</label>
                <Select size="small" value={userID || 0} onChange={(e) => handleAgentChange(e)} style={{ minWidth: '100%' }}>
                    <MenuItem value={null}>{``}</MenuItem>
                    {listUsers != null && listUsers.sort((a, b) => a.agencyName > b.agencyName ? 1 : -1).filter(a => a.active && a.idAgency > 0).map((user) => (
                        <MenuItem value={user.id}>{`[${user.agencyName}] ${user.firstName} ${user.lastName}`}</MenuItem>
                    ))}
                </Select>
                {creditNoteNumber &&
                    <Grid item xs={12}>
                        <p>Credit Note: {creditNoteNumber}</p>
                    </Grid>
                }
                {invoiceNumber &&
                    <Grid item xs={12}>
                        <p>Invoice: {invoiceNumber}</p>
                    </Grid>
                }
                <List sx={{ width: '100%', bgcolor: 'background.paper' }}  >
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(1)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 1]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 1));
                                }
                            }} />

                        <ListItemIcon>
                            <TaskIcon />
                        </ListItemIcon>
                        <ListItemText primary="Booking confirmation" />
                        <Switch edge="end" onChange={() => { setBookingConfirmationSent(!bookingConfirmationSent) }} checked={bookingConfirmationSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(2)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 2]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 2));
                                }
                            }} />
                        <ListItemIcon>
                            <ConnectingAirportsIcon />
                        </ListItemIcon>
                        <ListItemText primary="Transfer info" />
                        <Switch edge="end" onChange={() => { setTransferInfoSent(!transferInfoSent) }} checked={transferInfoSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(3)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 3]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 3));
                                }
                            }} />
                        <ListItemIcon>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary="Invoice (Gross)" />
                        <Switch edge="end" onChange={() => { setInvoiceSent(!invoiceSent) }} checked={invoiceSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(4)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 4]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 4));
                                }
                            }} />
                        <ListItemIcon>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary="Invoice (Net)" />
                        <Switch edge="end" onChange={() => { setInvoiceSent(!invoiceSent) }} checked={invoiceSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(5)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 5]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 5));
                                }
                            }} />
                        <ListItemIcon>
                            <CreditCardIcon />
                        </ListItemIcon>
                        <ListItemText primary="Payment Deposit Confirmation" />
                        <Switch edge="end" onChange={() => { setPaymentDepositConfirmationSent(!paymentDepositConfirmationSent) }} checked={paymentDepositConfirmationSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(6)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 6]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 6));
                                }
                            }} />
                        <ListItemIcon>
                            <CreditScoreIcon />
                        </ListItemIcon>
                        <ListItemText primary="Payment Confirmation" />
                        <Switch edge="end" onChange={() => { setPaymentConfirmationSent(!paymentConfirmationSent) }} checked={paymentConfirmationSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(7)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 7]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 7));
                                }
                            }} />
                        <ListItemIcon>
                            <FeaturedPlayListIcon />
                        </ListItemIcon>
                        <ListItemText primary="Visa" />
                        <Switch edge="end" onChange={() => { setVisaSent(!visaSent) }} checked={visaSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(8)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 8]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 8));
                                }
                            }} />
                        <ListItemIcon>
                            <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary="Credit Note" />
                        <Switch edge="end" onChange={() => { setCreditNoteSent(!creditNoteSent) }} checked={creditNoteSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                    <ListItem>
                        <Checkbox
                            inputProps={{ 'aria-label': 'controlled' }}
                            checked={selectedFileType.includes(9)}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedFileType([...selectedFileType, 9]);
                                } else {
                                    setSelectedFileType(selectedFileType.filter(type => type !== 9));
                                }
                            }} />
                        <ListItemIcon>
                            <WorkspacePremiumIcon />
                        </ListItemIcon>
                        <ListItemText primary="Certificate of Attendance" />
                        <Switch edge="end" onChange={() => { setCertificateSent(!certificateSent) }} checked={certificateSent == true} inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }} />
                    </ListItem>
                </List>


            </Grid>

            <Grid container justifyContent={'center'} spacing={2}>
                <Grid item xs={6}>
                    <Button loading={loading} variant='contained' m={1} sx={{ width: '100%' }} disabled={selectedFileType.length <= 0} onClick={() => { generateFile(false) }}>
                        DOWNLOAD
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button variant='contained' m={1} sx={{ width: '100%' }} disabled={selectedFileType.length <= 0} onClick={() => { generateFile(true) }}>
                        SEND BY MAIL
                    </Button>
                </Grid>
            </Grid>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Paper >

    )
}

export default DocumentsDetails